import React, { Component } from 'react'
import styled from 'styled-components'
import { Table, TableCell, TableHeader, TableLoading, Button, Pagination, TextIcon } from 'advenio-components'
import moment from 'moment'
import PropTypes from 'prop-types'
import queryString from 'query-string'
import { connect } from 'react-redux'
import ApplyModal from './ApplyModal'
import DeleteModal from './DeleteModal'

import MedicinesActions from '../../Data/Redux/MedicinesCenterRedux'
import ClassroomActions from '../../Data/Redux/ClassroomRedux'
import MedicineActions from '../../Data/Redux/ParentPlatform/MedicineRedux'
import MedicineModal from '../../Components/ParentPlatform/MedicineModal'

const Container = styled.div`
  padding: 24px;
`

const Info = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`

const PaginationContainer = styled.div`
  margin: 12px 0;
`

const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
`
const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`

const Profile = styled.div`
  background-image: ${props => props.profile ? `url( ${props.profile} )` : 'url(/assets/BabyAvatar.svg)'};
  background-size: cover;
  background-position: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border:  solid #CCCCCC 1px;
  margin-right: 10px;
`

const Span = styled.span`
  font-size: 24px;
  font-weight: bold;
`

const ActionButton = styled(Button)`
  width: 97px;
  margin: 4px 4px 4px 4px;
`

class Medicine extends Component {
  state = {
    applyModal: false,
    medicine_id: undefined,
    openMedicine: false,
    students: [],
    medicines: [],
    firstPageToRender: 1,
    lastPageToRender: 10,
    pageSelected: 1,
    queryParams: {},
    modalDelete:false,
    deleteMedicine:0

  }
  componentDidMount = () => {
    const { center_id } = this.props.user
    const queryParams = queryString.parse(this.props.location.search)
    if (queryParams.page) {
      this.setState({ pageSelected: Number(queryParams.page) })
    }
    this.setState({ queryParams })
    this.props.getMedicines(center_id, queryParams)
    // this.props.getClassromms()
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.classrooms) {
      const students = []
      const medicines = []
      let student = null
      for (let i = 0; i < nextProps.classrooms.length; i += 1) {
        for (let j = 0; j < nextProps.classrooms[i].students.length; j += 1) {
          students.push(
            {
              id: nextProps.classrooms[i].students[j].id,
              label: `${nextProps.classrooms[i].students[j].first_name || ''} ${nextProps.classrooms[i].students[j].last_name_paternal || ''} ${nextProps.classrooms[i].students[j].last_name_maternal || ''}`,
              value: nextProps.classrooms[i].students[j].id,
              checkin: nextProps.classrooms[i].students[j].checkin,
            },
          )
        }
      }
      this.setState({ students })
      if (nextProps.medicines_center && nextProps.medicines_center.length && students.length > 0) {
        for (let i = 0; i < nextProps.medicines_center.length; i += 1) {
          if (students.length > 0) {
            student = students.find(s => s.id === nextProps.medicines_center[i].student.id)
            if (student && student.checkin.id !== null && moment(moment().format('YYYY-MM-DD')).isSameOrBefore(nextProps.medicines_center[i].to_date)) {
              medicines.push(nextProps.medicines_center[i])
            }
          }
        }
        this.setState({ medicines })
      }
      else{
        this.setState({medicines:nextProps.medicines_center})
      }
    }
  }

  onClickPage = (page) => {
    this.setState({ pageSelected: page }, () => {
      const { queryParams } = this.state
      const { getMedicines, goTo } = this.props
      const { center_id } = this.props.user

      const queries = { ...queryParams, page }
      getMedicines(center_id, queries)
      goTo(`?${queryString.stringify(queries)}`)
    })
  }

  toggleApply = (medicine_id = undefined, apply) => {
    if (medicine_id) {
      this.setState({ applyModal: !this.state.applyModal, apply, medicine_id })
    } else {
      this.setState({ applyModal: !this.state.applyModal, apply })
    }
  }

  deleteApply = (medicine_id ) => {
    this.setState({ deleteMedicine: medicine_id, modalDelete:true})
  }

  deleteMedicine = () => {
    const { deleteMedicine } = this.state
    this.props.deleteMedicine(deleteMedicine)
  }

  submitApply = ({ comments }) => {
    const { apply, medicine_id } = this.state
    this.props.applyMedicine(medicine_id, { applied: apply, comments })
    this.toggleApply()
  }

  closeDeleteModal = () => this.setState({modalDelete:false})

  toggleMedicine = () => {
    this.setState({ openMedicine: !this.state.openMedicine })
  }

  render() {
    const { meta, classrooms } = this.props
    const { pageSelected, modalDelete } = this.state
    return (
      <Container>
        <TableContainer>
          <ButtonContainer>
            <Span>Medicamentos</Span>
            <Button success marginRight="0" disabled={classrooms.length === 0} onClick={this.toggleMedicine} loading={this.props.loading}>
              <TextIcon iconType={'plus'} label={'Medicamento'} />
            </Button>
          </ButtonContainer>
          <PaginationContainer>
            <Pagination
              totalElements={meta && meta.total}
              elementsPerPage={meta && meta.per_page}
              onPageClick={this.onClickPage}
              pageSelected={pageSelected}
            />
          </PaginationContainer>
          {this.props.loading ?
            <TableLoading
              roundedCorners
              columns={[
                {
                  id: 1,
                  header: 'Hora',
                  element: 'Text',
                  center: true,
                },
                {
                  id: 2,
                  header: 'Alumno',
                  element: 'Text',
                  center: true,
                },
                {
                  id: 3,
                  header: 'Medicamento y Dosis',
                  element: 'Text',
                  center: true,
                },
                {
                  id: 4,
                  header: 'Fechas',
                  element: 'Text',
                  center: true,
                },
                {
                  id: 5,
                  header: 'Comentarios',
                  element: 'Text',
                  center: true,
                },
                {
                  id: 6,
                  header: 'Acciones',
                  element: 'Text',
                  center: true,
                },
              ]}
              rows={10}
            />
            :
            <Table
              roundedCorners
              data={this.state.medicines}
              columns={[
                {
                  Header: () => <TableHeader title="Hora" blue center />,
                  accessor: 'apply_at',
                  maxWidth: 100,
                  Cell: ({ value }) => <TableCell center noEllipsis >{moment(value, 'HH:mm:SS').format('HH:mm')}</TableCell>,
                },
                {
                  id: 'info',
                  Header: () => <TableHeader title="Alumno" blue center />,
                  accessor: ({ student }) =>
                    ({ full_name: student.full_name, pictures: student.profile_pictures }),
                  Cell: ({ value }) => (<TableCell noEllipsis>
                    <Info>
                      <Profile profile={value.pictures && value.pictures['original']} />
                      {value.full_name}
                    </Info>
                  </TableCell>),
                },
                {
                  id: 'medicine',
                  Header: () => <TableHeader title="Medicamento y Dosis" blue center noEllipsis />,
                  accessor: medicine => ({ name: medicine.name, dose: medicine.dose }),
                  Cell: ({ value }) => (
                    <TableCell noEllipsis center>
                      {value.name} ({value.dose})
                    </TableCell>),
                },
                {
                  id: 'dates',
                  Header: () => <TableHeader title="Fechas" blue center noEllipsis />,
                  accessor: ({ from_date, to_date }) => ({ from_date , to_date }),
                  Cell: ({ value: { from_date , to_date } }) =>
                    (<TableCell noEllipsis center>
                      <span>{ moment(from_date).format('Y-M-D') } a { moment(to_date).format('Y-M-D') }</span>
                    </TableCell>),
                },
                {
                  Header: () => <TableHeader title="Comentarios" blue center noEllipsis />,
                  accessor: 'comments',
                  Cell: ({ value }) =>
                    (<TableCell noEllipsis>
                      <span>{value}</span>
                    </TableCell>),
                },
                {
                  Header: () => <TableHeader title="Acciones" blue center />,
                  accessor: 'id',
                  Cell: ({ value }) => (<TableCell center noEllipsis >
                    <ActionButton
                      onClick={() => { this.deleteApply(value) }}
                      danger
                      small
                    >
                      Eliminar
                    </ActionButton>
                    <ActionButton
                      onClick={() => { this.toggleApply(value, false) }}
                      danger
                      small
                    >
                     No Aplicar
                    </ActionButton>
                    <ActionButton
                      onClick={() => { this.toggleApply(value, true) }}
                      primary
                      small
                    >
                      Aplicar
                    </ActionButton>
                  </TableCell>),
                },
              ]}
            />
          }
          <MedicineModal
            onClose={this.toggleMedicine}
            open={this.state.openMedicine}
            createMedicine={this.props.createMedicine}
            loading={this.props.loadingMedicine}
            students={this.state.students}
            fromCenter
          />
        </TableContainer>
        <ApplyModal
          open={this.state.applyModal}
          onClose={this.toggleApply}
          apply={this.state.apply}
          submitApply={this.submitApply}
          loading={this.props.loadingMedicine}
        />
        <DeleteModal
          open={modalDelete}
          onClose={this.closeDeleteModal}
          submitApply={this.deleteMedicine}
          loading={this.props.loadingMedicine}
        />
      </Container>
    )
  }
}

Medicine.propTypes = {
  loading: PropTypes.bool.isRequired,
  loadingMedicine: PropTypes.bool.isRequired,
  classrooms: PropTypes.array.isRequired,
  medicines_center: PropTypes.array,
  goTo: PropTypes.func,
  meta: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.object,
  ]),
  location: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.object,
  ]),
  user: PropTypes.object.isRequired,
  getMedicines: PropTypes.func.isRequired,
  getClassromms: PropTypes.func.isRequired,
  createMedicine: PropTypes.func.isRequired,
  applyMedicine: PropTypes.func.isRequired,
}

Medicine.defaultProps = {
  inscriptions: [],
  meta: () => {},
  goTo: () => {},
  location: {},
  medicines_center: [],
}

const mapStateToProps = state => ({
  medicines_center: state.medicines_center.get.results.data,
  meta: state.medicines_center.get.results.meta,
  links: state.medicines_center.get.results.links,
  user: state.auth.user,
  loadingMedicine: state.parent_platform_medicine.medicine.fetching || state.medicines_center.sending.fetching,
  classrooms: state.classrooms.get.results,
  loading: state.classrooms.get.fetching,
})

const mapDispatchToProps = dispatch => ({
  getMedicines: (center_id, queries) =>
    dispatch(MedicinesActions.getRequest(center_id, queries)),
  getClassromms: () => dispatch(ClassroomActions.getRequest()),
  createMedicine: medicine => dispatch(MedicineActions.createMedicineRequest(medicine)),
  applyMedicine: (medicine_id, apply_info) =>
    dispatch(MedicinesActions.applyMedicineRequest(medicine_id, apply_info)),
  deleteMedicine: (medicine_id) =>
    dispatch(MedicinesActions.deleteMedicineRequest(medicine_id)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Medicine)



// WEBPACK FOOTER //
// ./src/Containers/Medicine/index.jsx